<template>
  <div class="course-place text-btn_secondary" :class="{lock: editable && place.lock}">
    <div class="mark-place text-place">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.738007H14V23.738L7 19.965L0 23.738V0.738007Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3H13V4H1V3Z" fill="white"/>
      </svg>
    </div>
    <div class="course-time text-right font-bold">
      <p>{{ routeArrivalTime }}</p>
      <p>{{ nextDepartureTime }}</p>
    </div>
    <div class="course-place-info">
      <div class="course-place-info-inner">
        <div class="course-place-info-number w-6 h-6 ml-1 text-center border font-bold text-white flex-shrink-0">
          {{ routeIndex + 1 }}
        </div>
        <div>
          <place-icon :place="place" />
        </div>
        <div class="course-name text-body text-lg leading-5 font-bold break-all">
          {{ place.name }}
          <a v-if="place.detail" @click="showModal(place)" class="text-link text-sm">(詳細)</a>
        </div>
        <div class="plan-icon ml-1 mr-2">
          <a @click="showMap">
            <img src="@/assets/images/icon-plan-map.svg" :alt="$t('tour_map_label')" />
          </a>
        </div>
      </div>
      <p class="course-visit text-btn_secondary-lighter mt-1 ml-3">
        {{ visitTime }}
      </p>
    </div>
    <div v-if="editable" class="button-edit relative text-link">
      <place-button :action="toggleEditMenu" :name="$t('tour_edit_label')" />
      <edit-menu
        v-show="showEditMenu"
        :place="place"
        @changeVisit="onChangeVisit"
        @deleteDestination="onDeleteDestination"
        @changeTime="onChangeTime" />
    </div>
    <poi-modal v-show="modal.show" :closeModal="() => closeModal()">
      <course-place-detail v-if="modal.show" :place="place" />
    </poi-modal>
  </div>
</template>

<script>
import PlaceIcon from "../atoms/PlaceIcon"
import PlaceButton from "../atoms/PlaceButton"
import EditMenu from "./EditMenu"
import PoiModal from "../molecules/PoiModal"
import CoursePlaceDetail from '../molecules/CoursePlaceDetail'

export default {
  components: {
    PlaceIcon,
    PlaceButton,
    EditMenu,
    PoiModal,
    CoursePlaceDetail
  },
  props: {
    place: {
      type: Object,
      required: true
    },
    changeVisit: {
      type: Function,
      default: function () {
        return {}
      }
    },
    deleteDestination: {
      type: Function,
      default: function () {
        return {}
      }
    },
    changeTime: {
      type: Function,
      default: function () {
        return {}
      }
    },
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    route: {
      type: Object,
      required: true
    },
    next: {
      type: Object,
      default: function () {
        return {}
      }
    },
    routeIndex: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showEditMenu: false,
      modal: {
        show: false
      }
    }
  },
  computed: {
    visitTime: function () {
      const time = this.place.visit
      return `${this.$t('tour_residence_time_label')}：${this.$t('tour_about_label')}` + (time / 60 >= 1 ? Math.floor(time / 60) + this.$t('tour_hour_label') : "") + (time % 60 !== 0 ? time % 60 + this.$t('tour_minute_label') : "");
    },
    routeArrivalTime: function () {
      const t = this.route.arrivalTime
      return t.format("HH:mm")
    },
    nextDepartureTime: function () {
      const t = this.next.departureTime
      return t ? t.format("HH:mm") : ''
    }
  },
  methods: {
    toggleEditMenu: function () {
      this.showEditMenu = !this.showEditMenu
    },
    onChangeVisit: function () {
      this.showEditMenu = false
      this.changeVisit()
    },
    onChangeTime: function () {
      this.showEditMenu = false
      this.changeTime()
    },
    onDeleteDestination: function () {
      this.showEditMenu = false
      this.deleteDestination()
    },
    onSetDatetime: function () {
      this.showEditMenu = false
      this.setDatetime()
    },
    showMap: function () {
      const location = this.place.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$store.dispatch('map/updateFrom', { name: 'plan' })
      this.$emit('openMap')
    },
    showModal () {
      this.modal.show = true
    },
    closeModal () {
      this.modal.show = false
    }
  }
}
</script>
